import { useEffect } from 'react';
import { getMinMaxBoundCoordinates } from './utils/fit-bounds';
export function useMapReactions(props) {
    const { mapRef, mapLoaded, markers, fitBound, flyToCoordinates, innerSelectedMarker, outerSelectedMarker, setSelectedMarker, } = props;
    const flyTo = (marker) => {
        mapRef === null || mapRef === void 0 ? void 0 : mapRef.flyTo({
            center: [
                marker.longitude,
                marker.latitude + 0.01, // to leave more space under the marker for popup
            ],
            duration: 1500,
            zoom: 12,
        });
    };
    // bound markers if "fitBound" set
    useEffect(() => {
        if (!mapRef || !fitBound || !(markers === null || markers === void 0 ? void 0 : markers.length)) {
            return;
        }
        const minMaxBoundCoordinates = getMinMaxBoundCoordinates(markers);
        if (!minMaxBoundCoordinates) {
            return;
        }
        mapRef === null || mapRef === void 0 ? void 0 : mapRef.fitBounds(minMaxBoundCoordinates, {
            padding: 60,
            duration: 400,
        });
    }, [mapRef, markers, fitBound, mapLoaded]);
    // fly to coordinates, when "flyToCoordinates" specified
    useEffect(() => {
        if (!flyToCoordinates) {
            return;
        }
        flyTo(flyToCoordinates);
    }, [mapRef, flyToCoordinates]);
    // set and fly to selected marker with opening popup if it's selected outside
    useEffect(() => {
        if (!outerSelectedMarker) {
            setSelectedMarker(undefined);
            return;
        }
        // if marker is changed - close popup by clearing selected marker
        if (outerSelectedMarker.latitude !== (innerSelectedMarker === null || innerSelectedMarker === void 0 ? void 0 : innerSelectedMarker.latitude) ||
            outerSelectedMarker.longitude !== (innerSelectedMarker === null || innerSelectedMarker === void 0 ? void 0 : innerSelectedMarker.longitude)) {
            setSelectedMarker(undefined);
        }
        flyTo(outerSelectedMarker);
        // open popup when map fly is finished
        mapRef === null || mapRef === void 0 ? void 0 : mapRef.once('moveend', () => setSelectedMarker(outerSelectedMarker));
    }, [mapRef, outerSelectedMarker]);
}
export default useMapReactions;
